export const CHART_STYLES = {
  RADIUS: {
    CARD: 8,
    BAR: 6,
    PIE: 6,
    SMALL: 6,
    TOOLTIP: 8,
  },

  DIMENSIONS: {
    MIN_CHART_SIZE: 120,
    PIE_INNER_RADIUS: 40,
    PIE_OUTER_RADIUS: 70,
    PIE_TOPIC_INNER_RADIUS: 40,
    PIE_TOPIC_OUTER_RADIUS: 70,
    TOOLTIP_MAX_WIDTH: 320,
  },

  COLORS: {
    PRIMARY: '#8884d8',
    GRID: '#f0f0f0',
    AXIS: '#666',
    TOOLTIP_BG: '#ffffff',
    TOOLTIP_BORDER: '#e5e7eb',
    TOOLTIP_TEXT: '#111827',
    TOOLTIP_TEXT_SECONDARY: '#6b7280',

    LEGEND_INDICATOR_SIZE: 10,
  },

  ANIMATION: {
    DURATION: 300,
    EASING: 'ease-out',
    DELAY: 100,
  },
} as const;
